import Stripe from "./StripeRedirectPage";

export default Stripe;
